import { Button, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useBaseData } from "../../../common/useBaseData";
import { OrgInfoFields, OrgInfoFieldValues } from "../shared/OrgInfoFields";

export type RegisterOrganizationFormValues = OrgInfoFieldValues;

interface Props {
  isSubmitting: boolean;
  defaultValues?: RegisterOrganizationFormValues;
  onContinue: (values: RegisterOrganizationFormValues) => Promise<void> | void;
}

export const RegisterOrganizationForm = ({ isSubmitting, defaultValues, onContinue }: Props) => {
  const { t } = useTranslation();
  const baseData = useBaseData();
  const norwayCountryId = baseData.countries.find((c) => c.alpha3Code === "NOR")?.id;

  const methods = useForm<RegisterOrganizationFormValues>({
    defaultValues: { countryId: norwayCountryId, ...defaultValues },
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onContinue)}>
        <OrgInfoFields />
        <Flex mt="20px" justifyContent="start">
          <Button type="submit" colorScheme="teal" isLoading={isSubmitting}>
            {t("Continue")}
          </Button>
        </Flex>
      </form>
    </FormProvider>
  );
};
